import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../assets/static/images/logo.png";

import LoadingModal from "../LoadingModal/LoadingModal";
import logouticon from "../../assets/static/images/logout.png";
import { logout } from "../../utils/auth";
import TooltipText from "../TooltipText";

import "./Header.css";

const Header = () => {
  const { loggedIn, user } = useSelector(({ authentication }) => authentication);
  const { loading } = useSelector(e => e.dashboard);

  const handleClick = () => {
    logout();
  };

  return (
    <div className="header">
      <div className="header-logo">
        <Link to={"/home"}>
          <img src={logo} alt="logo" className="logo" />
        </Link>
      </div>
      {loggedIn ? (
        <div className="header-user">
          <div className="user">
            <span>{user?.apellido} {user?.nombre} ({user?.abogado})</span>
          </div>
          <div className="line"></div>
          <div className="logout">
            <TooltipText placement="bottom" text="Cerrar sesión" >
              <img src={logouticon} alt="logout" onClick={handleClick} />
            </TooltipText>
          </div>
        </div>
      ) : null}
      {loading ? <LoadingModal show={loading} loading={true} /> : null}
    </div>
  );
};

export default Header;